// src/api/axiosInstance.js
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const axiosInstance = axios.create({
 baseURL: BASE_URL,
});

// ============================
// REQUEST INTERCEPTOR
// ============================
axiosInstance.interceptors.request.use(
 (config) => {
 const token = localStorage.getItem("token");
 if (token) {
 config.headers["Authorization"] = `Bearer ${token}`;
 }
 return config;
 },
 (error) => Promise.reject(error)
);

// ============================
// RESPONSE INTERCEPTOR
// ============================
axiosInstance.interceptors.response.use(
 (response) => {
 return response;
 },
 async (error) => {
 const originalRequest = error.config;
 const status = error.response?.status;
 const backend = error.response?.data;

 // -------------------------
 // SUSPENDED USER: DO NOT REDIRECT
 // -------------------------
 if (backend?.status === "SUSPENDED" || backend?.isSuspended) {
 return Promise.reject(error);
 }

 // -------------------------
 // AUTO REFRESH TOKEN ON 401
 // -------------------------
 if (status === 401 && !originalRequest._retry) {
 originalRequest._retry = true;
 const storedRefreshToken = localStorage.getItem("refreshToken");

 if (!storedRefreshToken) {
 window.location.href = "/register";
 return Promise.reject(error);
 }

 try {
 const res = await axiosInstance.post("/auth/refresh", {
 refreshToken: storedRefreshToken,
 });

 const newToken = res.data.token;
 const newRefreshToken = res.data.refreshToken;

 localStorage.setItem("token", newToken);
 if (newRefreshToken) {
 localStorage.setItem("refreshToken", newRefreshToken);
 }

 originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
 return axiosInstance(originalRequest);
 } catch (refreshError) {
 localStorage.removeItem("token");
 localStorage.removeItem("refreshToken");
 localStorage.removeItem("user");
 window.location.href = "/register";
 return Promise.reject(refreshError);
 }
 }

 // -------------------------
 // 403 — do not redirect, let caller handle
 // -------------------------
 if (status === 403 && backend?.status !== "SUSPENDED") {
 // no-op: caller receives the rejected promise
 }

 return Promise.reject(error);
 }
);

export default axiosInstance;
